<template>
  <div class="container mx-auto p-6 md:p-0" style="">

    <div class="block mb-6" v-if="showSelect">
      <div class="grid " :class="{'grid-cols-2':eventTags && eventTags.length>0,'grid-cols-1':!eventTags || eventTags.length==0}">
        <div class="mt-1 block form mb-4">
          <div class="text-sm text-gray-400 my-1">{{ labels && labels.event_type ? labels.event_type : '' }}</div>
          <t-select v-if="eventTypes"
              placeholder="-"
              :options="eventTypes"
              value-attribute="id"
              text-attribute="display_name"
              classes="text-black placeholder-gray-400 bg-white border-gray-200"
              fixed-classes="border text-xs p-1 w-full pl-3 pr-10 text-sm rounded-md"


              v-model="selectedEventType"
          ></t-select>
        </div>
        <div class="mt-1 block form mb-4" v-if="eventTags && eventTags.length>0">
          <div class="text-sm text-gray-400 my-1">{{ labels && labels.topic ? labels.topic : '' }}</div>
          <t-select
              placeholder="-"
              :options="eventTags"
              value-attribute="id"
              text-attribute="text"
              classes="text-black placeholder-gray-400 bg-white border-gray-200"
              fixed-classes="border text-xs p-1 w-full pl-3 pr-10 text-sm rounded-md"

              v-if="eventTags"
              v-model="selectedEventTag"
          ></t-select>
        </div>
      </div>

    </div>
    <!-- This example requires Tailwind CSS v2.0+ -->

    <div class="flex items-center justify-center" v-if="loading" >
      <i class="fal fa-circle-notch fa-spin text-4xl text-gray-400"></i>
    </div>


    <transition-group name="list" tag="div"
                      class="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 " v-if="layout==1">
      <a  @mouseenter="selectedId=item.id" @mouseleave="selectedId=null" :href="translateField(item.url)?translateField(item.url):'#'" class="col-span-1 flex flex-col text-center bg-white
      rounded-md  relative
transform transition-all duration-200 ease-in-out
"
         :class="{'cursor-default':!translateField(item.url),' hover:scale-105 shadow-lg ':translateField(item.url)}"
          v-for="item in items" :key="item.id">

        <div class="absolute w-full z-0 bg-white  h-full rounded-md" :style="{'background': 'url('+item.backgroundImage.md+') center center / cover no-repeat'}" style="mask-image: linear-gradient(to bottom right, rgba(0,0,0,.08) 40%, rgba(0,0,0,.25) 90%);" v-if="item.backgroundImage"></div>

        <div class="absolute flex justify-center w-full z-10">


            <div
                class=" top-0 whitespace-nowrap -mt-2 shadow-sm  rounded px-1.5 py-0.5  text-xs mx-auto font-medium text-gray-600 bg-gray-50 relative z-10">

            <span class="font-mono" v-if="item.key_status_id!=67">
              <i class="fal fa-calendar-alt mr-1"></i> {{ item.localizedStartDateString }}
            </span>
            <span class="font-mono" v-if="item.key_status_id==67">
              <i :class="item.key_status.icon" class="fal mr-1"></i> {{ item.key_status.localized_display_name }}
            </span>

          </div>


        </div>

        <div class="flex-1 flex flex-col p-4  relative z-10">




          <h3 class="mt-1.5 text-gray-900 text-xs font-light relative">

            <i class="fal" :class="item.key_type.icon"></i>

            {{ item.key_type.display_name }}</h3>
          <h3 class="mt-0.5 text-gray-900 text-sm font-medium leading-tight relative">
            <div class="absolute top-0 left-0 bg-white opacity-80 h-full w-full z-0"
                 style="filter: blur(30px);"></div>
           <span class="relative z-20  font-semibold">{{ translateField(item.name) }}</span> </h3>
          <h4 class="mt-0.5 text-gray-900 text-sm font-normal leading-none relative mt-0.5" v-if="translateField(item.subname)"
              style="text-wrap: pretty;">

            <span class="relative z-20 ">{{ translateField(item.subname) }}</span></h4>
          <dl class="mt-0.5 flex-grow flex justify-center items-end">

            <dd class="text-gray-700 text-xs "  v-if="item.key_status_id!=67">{{ item.localizedTimeString }}</dd>

          </dl>




        </div>


        <div v-if="true==false"
            :class="{'invisible  opacity-0':selectedId!=item.id,'visible  opacity-100':selectedId==item.id}"
            class="


          transition-all
          duration-300

          absolute
          left-1/2
          top-1/2
          -translate-x-1/2 -translate-y-1/2
          rounded-full
          p-4
          bg-black bg-opacity-80
          border border-gray-300
        "
        >
          <div class="mt-2 transition-all transform duration-200" v-show="selectedId==item.id" >
              <span href="#"
                    class="relative inline-flex items-center rounded-md border border-gray-100 px-0.5  inline-block m-0.5"
                    v-for="tag in item.tagArray" :key="tag.id">
                <div class="absolute flex-shrink-0 flex items-center justify-center ">
                  <span class="h-1 w-1 rounded-full " :class="getColorClass(tag.inheritedColor)"
                        aria-hidden="true"></span>
                </div>
                <div class="ml-2 text-xxs font-light text-gray-500 "
                     style="font-size: .71em;">{{ truncate(translateField(tag.name), 30) }}</div>
              </span>
          </div>
        </div>
      </a>

      <li class="col-span-1 flex flex-col justify-center text-center bg-white rounded-lg relative" key="showAll" v-if="itemsTotal.length >items.length">
        <div class="">
          <div class="cursor-pointer rounded-md px-2 py-1 border border-primary-300 text-xs inline-block font-bold text-primary-500 hover:scale-102 duration-150 transition-all transform" @click="disableLimit=true">
            <i class="fal fa-calendar-alt"></i>   {{ labels && labels.show_all ? labels.show_all : '' }} ({{itemsTotal.length}})
          </div>
        </div>

      </li>
    </transition-group>

    <transition-group  v-if="layout==2" name="list" tag="div"
                      class="grid grid-cols-1 gap-12 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 relative">
      <a  @mouseenter="selectedId=item.id" @mouseleave="selectedId=null" :href="translateField(item.url)?translateField(item.url):'#'"  class="col-span-1 flex flex-col text-center bg-white
      rounded-md  relative
transform transition-all duration-200 ease-in-out
"

         :class="{'cursor-default':!translateField(item.url),' hover:scale-105 shadow-lg ':translateField(item.url)}"
          v-for="item in items" :key="item.id">
        <div class="absolute w-full z-0 bg-white bg-opacity-30 h-full z-0 rounded-md  overflow-hidden" :style="{'background': 'url('+item.backgroundImage.md+') center center / cover no-repeat'}" v-if="item.backgroundImage"></div>
        <div class="absolute flex justify-center w-full z-10 rounded-md" >


            <div
                class=" top-0 whitespace-nowrap -mt-2.5 shadow-sm  rounded px-1.5 py-0.5  text-sm mx-auto font-medium text-gray-500 bg-gray-50 lg:text-sm tracking-tighter">
              <i class="fal fa-calendar-alt mr-1"></i> {{ item.localizedDateString }}

          </div>


        </div>

        <div class="flex-1 flex items-center justify-center p-4 z-20">


          <div class=" h-28 py-1.5  flex items-center justify-center" v-if="item.logo && !item.logo.default">
            <img class="mx-auto bg-white rounded-md object-contain p-4 shadow-md" v-if="item.logo && item.logo['oar-md']"
                 :src="item.logo['oar-md']" alt="" style="max-height: 7.3rem;">
          </div>
<span v-if="item.logo && item.logo.default" class="text-white">
  <h3 class="mt-8 text-gray-900 text-xs font-light text-white"><i class="fal" :class="item.key_type.icon"></i>
            {{ item.key_type.display_name }}</h3>
          <h3 class="mt-2 text-gray-900 text-sm font-mediumn text-white">{{ translateField(item.name) }}</h3>
    <h4 class="mt-0.5 text-gray-900 text-sm font-normal leading-none relative text-white" v-if="translateField(item.subname)"
        style="text-wrap: pretty;">

                      <span class="relative z-20 ">{{ translateField(item.subname) }}</span></h4>
</span>

          <dl class="mt-1 flex-grow flex justify-center items-end" v-if="true==false">

            <dd class="text-xs mt-2 text-gray-800 bg-white rounded-md px-1 py-0.5 mb-1 shadow-sm font-normal"  ><i class="fal fa-calendar-alt mr-1"></i>  {{ item.localizedTimeString }}</dd>

          </dl>




        </div>


        <div v-if="true==false"
            :class="{'invisible  opacity-0':selectedId!=item.id,'visible  opacity-100':selectedId==item.id}"
            class="


          transition-all
          duration-300

          absolute
          left-1/2
          top-1/2
          -translate-x-1/2 -translate-y-1/2
          rounded-full
          p-4
          bg-black bg-opacity-80
          border border-gray-300
        "
        >
          <div class="mt-2 transition-all transform duration-200" v-show="selectedId==item.id" >
              <span href="#"
                    class="relative inline-flex items-center rounded-md border border-gray-100 px-0.5  inline-block m-0.5"
                    v-for="tag in item.tagArray" :key="tag.id">
                <div class="absolute flex-shrink-0 flex items-center justify-center ">
                  <span class="h-1 w-1 rounded-full " :class="getColorClass(tag.inheritedColor)"
                        aria-hidden="true"></span>
                </div>
                <div class="ml-2 text-xxs font-light text-gray-500 "
                     style="font-size: .71em;">{{ truncate(translateField(tag.name), 30) }}</div>
              </span>
          </div>
        </div>
      </a>

      <li class="col-span-1 flex flex-col justify-center text-center bg-white rounded-lg relative" key="showAll" v-if="itemsTotal.length >items.length">
        <div class="">
          <div class="cursor-pointer rounded-md px-2 py-1 border border-primary-300 text-xs inline-block font-bold text-primary-500 hover:scale-102 duration-150 transition-all transform" @click="disableLimit=true">
            <i class="fal fa-calendar-alt"></i>   {{ labels && labels.show_all ? labels.show_all : '' }} ({{itemsTotal.length}})
          </div>
        </div>

      </li>
    </transition-group>

  </div>

</template>

<script>
import WidgetMixin from './WidgetMixin';

import {TSelect, TRichSelect} from 'vue-tailwind';
import _ from 'lodash';


export default {
  name: "EventCalendar",
  mixins: [WidgetMixin],
  components: {TSelect},
  data() {
    return {
      calender: {},
      tree: {},
      selectedId: null,
      selectedEventType: null,
      labels: null,
      selectedEventTag: null,
      disableLimit: false,
      loading: false,
    }
  },

  watch: {},

  props: {
    limit: {
      type: Number,
      default: 999,
    },
    archive: {
      type: Boolean,
      default: false,
    },
    eventType: {
      type: Number,
      default: null,
    },
    topicTag: {
      type: Number,
      default: null,
    },
    showSelect: {
      type: Boolean,
      default: true,
    },
    layout: {
      type: Number,
      default: 1,
    },
  },

  mounted() {
    if(this.eventType){
      this.selectedEventType=parseInt(this.eventType,10)
    }
    if(this.topicTag){
      this.selectedEventTag=parseInt(this.topicTag,10)
    }

    },

  computed: {
    items() {
      if (this.disableLimit)
        return this.itemsTotal

      return _.take(this.itemsTotal, this.limit)
    },
    itemsTotal() {
      if(this.archive){
        var filteredItems =_(this.calender).sortBy('start_date').reverse();
      }else{
        var filteredItems =_(this.calender).sortBy('start_date');
      }

      var items = filteredItems.reject((o) => {
        return this.selectedEventType && o.key_type.id != this.selectedEventType
      }).reject((b) => {

        return this.selectedEventTag && !b.tagArray.includes(parseInt(this.selectedEventTag))
      }).value()
      if (items.length == 0) {
        setTimeout(() => {
          this.selectedEventTag = null
        }, 250)

      } else {


      }

      return items
    },
    eventTypes() {
      return _(this.calender).map('key_type').keyBy('id').sortBy('display_name').value()
    },
    eventTags() {
      if (!this.tree) {
        return []
      }
      var availableTags = _(this.calender)

          .reject(o => {
            return this.selectedEventType && this.selectedEventType != o.key_type.id
          })
          .reject(o => {
            return _.isArray(o.tagArray) && o.tagArray.length == 0
          })
          .map(b => {
            return _.values(b.tagArray)
          }).flatten().value()


      // return availableTags
      return _.reject(this.tree, (o) => {
        return !availableTags || !availableTags.includes(o.id)
      })

    }
  },

  methods: {

    truncate(str, length, ending) {
      if (length == null) {
        length = 100;
      }
      if (ending == null) {
        ending = '...';
      }
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    },

    getColorClass(color) {
      var css = {}

      css['bg-' + color + "-300"] = true

      return css
    },
    getHtml() {

      var lang = "de"

      if (window.appSettings && window.appSettings.appLanguage) {
        lang = window.appSettings.appLanguage
      }

      this.loading = true

      axios.get('https://' + this.domain + '/api/customer/widget/calendar/' + "?lang=" + lang+'&archive='+this.archive).then(response => {

        this.loading = false
            //console.log(response.data)
            this.calender = response.data.calendar
            this.tree = response.data.tree
            this.labels = response.data.labels

        this.$nextTick(()=>{
          if(this.eventType){
            this.selectedEventType=parseInt(this.eventType)
          }
      if(this.topicTag){
            this.selectedEventTag=parseInt(this.topicTag)
          }
        })



          }
      ).catch(error => {
        this.loading = false

      })
    }
  }
}
</script>

<style  lang="scss">

$delay: 20ms;
$delayStep: 100ms;

.fade-enter,
.fade-leave-to {
  & > * {
    opacity: 0;
    transform: translateY(40px);
  }
}
.fade-enter-active {
  & > * {
    &:nth-child(2) {
      transition-delay: $delay;
    }
    &:nth-child(3) {
      transition-delay: $delay + $delayStep;
    }
  }
}
.fade-leave-active {
  & > * {
    &:nth-child(1) {
      transition-delay: $delay + $delayStep;
    }
    &:nth-child(2) {
      transition-delay: $delay;
    }
  }
}
.fade-move {

  transition: 500ms ease-in-out;
  transition-property: all;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(194, 188, 188, 0.2);
  border-right: 1.1em solid rgba(194, 188, 188, 0.2);
  border-bottom: 1.1em solid rgba(194, 188, 188, 0.2);
  border-left: 1.1em solid #c2bcbc;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

.list-enter-active,
.list-leave-active,
.list-move {

  transition: 500ms ease-in-out;
  transition-property: all;
}

.list-enter {
  opacity: 0;
  transform: scale(0.1);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scale(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: translateY(-50px) scale(0.01);
  transform-origin: center ;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>